import "./_faq.scss";

export default function Faq() {
    const faqComponent = document.querySelectorAll('.faq');
    if (faqComponent.length > 0) {
        faqComponent.forEach(question => {
            const questions = question.querySelectorAll('.accordion-wrapper')

            const input = Array.from(question.querySelectorAll("input"));
            const label = Array.from(question.querySelectorAll("label"));

            input.forEach((el, index) => {
                el.setAttribute('id', `question-${index}`);
                label.forEach((item, index) => {
                    item.setAttribute('for', `question-${index}`)
                })
                el.addEventListener('change', e => {
                    // @ts-ignore
                    if (e.target.checked === true) {
                        ((e.target as HTMLElement).closest('div.accordion-wrapper') as HTMLElement).classList.add('active');
                        const headerActive = document.querySelectorAll('.accordion-wrapper.active .accordion-header');

                        headerActive.forEach(el => {
                            el.setAttribute('aria-label', 'riduci dettagli');
                        })
                        // @ts-ignore
                    } else if (e.target.checked === false) {
                        ((e.target as HTMLElement).closest('div.accordion-wrapper') as HTMLElement).classList.remove('active');
                        const headerActive = document.querySelectorAll('.accordion-wrapper .accordion-header');

                        headerActive.forEach(el => {
                            el.setAttribute('aria-label', 'espandi dettagli');
                        })
                    }
                })
            })

            questions.forEach((item) => {
                const accordionHeader = item.querySelector('.accordion-header') as HTMLElement;
                accordionHeader.addEventListener('keypress', function (e) {
                    const inputAccordion = item.querySelector('input') as HTMLElement;
                    if (inputAccordion.getAttribute('checked') === null) {
                        if (e.code === 'Enter') {
                            inputAccordion.setAttribute('checked', 'checked');
                            item.classList.add('active');
                            accordionHeader.setAttribute('aria-label', 'riduci dettagli');
                        }
                    } else if (inputAccordion.getAttribute('checked') === 'checked') {
                        if (e.code === 'Enter') {
                            inputAccordion.removeAttribute('checked');
                            item.classList.remove('active');
                            accordionHeader.setAttribute('aria-label', 'espandi dettagli');
                        }
                    }
                })
            })
        })
    }
}